import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  ViewChild,
  signal,
} from '@angular/core';
import { CanComponentDeactivate } from '@app/core/auth/can-component-deactivate.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandFormWrapperComponent } from '../components/brand-form-wrapper/brand-form-wrapper.component';
import {
  BrandFormConfig,
  BRAND_HEADER_ACTIONS,
  createBrandFormFields,
  BrandItem,
} from '../brand.config';
import { BrandService } from '../services/brand.service';

@Component({
  selector: 'app-brand-edit',
  standalone: true,
  imports: [BrandFormWrapperComponent],
  templateUrl: './brand-edit.component.html',
  styleUrls: ['./brand-edit.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BrandEditComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('formWrapper') private readonly formWrapper?: BrandFormWrapperComponent;

  config: BrandFormConfig = {
    title: 'brand.form.edit.title',
    formFields: createBrandFormFields(),
    headerActions: BRAND_HEADER_ACTIONS,
    listRoute: '/goods/brand',
  };

  // Data signals
  brandData = signal<BrandItem | null>(null);
  loading = signal(false);

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private brandService: BrandService
  ) {}

  ngOnInit(): void {
    this.loadBrandData();
  }

  canDeactivate(): boolean {
    return this.formWrapper?.canDeactivate() ?? true;
  }

  private loadBrandData(): void {
    const brandId = this.route.snapshot.queryParams['id'];

    if (!brandId) {
      this.router.navigate(['/goods/brand']);
      return;
    }

    this.loading.set(true);
    this.brandService.getBrandById(brandId).subscribe({
      next: (brand) => {
        this.loading.set(false);
        if (brand) {
          this.brandData.set(brand);
        } else {
          this.router.navigate(['/goods/brand']);
        }
      },
      error: (error) => {
        this.loading.set(false);
        this.router.navigate(['/goods/brand']);
      },
    });
  }
}
